import React from 'react';
import { Container } from '../components.js';

/*
props needed
label
addClass (optional)
bgcolor
size (optional)
icon_src
icon_alt
formatData(data)
objectToCall
apiCall(cb)
*/

class SingleDataContainer extends React.Component {

	constructor(props) {
		super(props);

		this.getData = this.getData.bind(this);

		this.state = { retrieval : {data :{}, dataError: false}};
	}

	componentDidMount() {
		
		if(this.state.retrieval.data !== null && Object.keys(this.state.retrieval.data).length === 0 && this.state.retrieval.dataError === false) {
			this.getData();
		}
	}

	getData() {
		
		var component = this;

		var callback = function(response) {
			if(response.code === 200) {
				if(response.detail !== "Report generated") {
						component.setState({retrieval: { data : {}, dataError : response.detail}});
				}
				else {
					component.setState({retrieval: { data : response.data, dataError : response.detail}});
				}
			}
			else {
				component.setState({retrieval: { data : {}, dataError : response.detail}});
			}
		};
		
		this.props.objectToCall[this.props.apiCall](callback);
	}

	render() {
		const containerSize = {
			width: (this.props.size) ? this.props.size.width : '22vmin',
			height: (this.props.size) ? this.props.size.height : '27vmin'
		};
		
		const label = this.props.label;
		
		var formattedData = '';
		if(this.state.retrieval && this.state.retrieval.data && Object.keys(this.state.retrieval.data).length) {
			formattedData = this.props.formatData(this.state.retrieval.data);
		}
	  	const containerContent = (this.state.retrieval && this.state.retrieval.data && Object.keys(this.state.retrieval.data).length) ? (<div className="Data-Div"><img className="Data-Icon" src={"/images/" + this.props.icon_src} alt={this.props.icon_alt} /><br />{formattedData} </div> ) : (this.state.retrieval.dataError) ? 'Unable to get ' + label : 'Loading...';

  		return (
      		<Container key={label + 'datakey'} moreClass={"App-ChartsLeft " + this.props.addClass} 
      		moreTitleClass={"App-ChartsTitle"} titles={ [ {'label' : label, 'onClick' : ''} ]} 
      		contents={containerContent} size={containerSize} onclick={this.props.onclick} bgcolor={this.props.bgcolor} />
  		);
	}
}


export default SingleDataContainer;








